import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Logo</title>
    <g>
      <g id="D" transform="translate(0.000000, 0.000000)">
        <path
          d="M37.696 67V33.4H50.272C53.472 33.4 56.32 34.072 58.816 35.416C61.312 36.744 63.272 38.664 64.696 41.176C66.12 43.672 66.832 46.68 66.832 50.2C66.832 53.72 66.12 56.736 64.696 59.248C63.272 61.744 61.312 63.664 58.816 65.008C56.32 66.336 53.472 67 50.272 67H37.696ZM43.84 61.528H50.272C52.448 61.528 54.264 61.072 55.72 60.16C57.176 59.248 58.272 57.944 59.008 56.248C59.744 54.552 60.112 52.536 60.112 50.2C60.112 47.864 59.744 45.848 59.008 44.152C58.272 42.456 57.176 41.152 55.72 40.24C54.264 39.328 52.448 38.872 50.272 38.872H43.84V61.528Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLogo;
